// Phase 13 — Timezone-aware event time formatter.
// Always show local time first; pin an ET secondary line for clarity.

export function formatEventTime(utcIso) {
  if (!utcIso) return { local: "TBA", et: "TBA", iso: utcIso };
  const dt = new Date(utcIso);
  if (Number.isNaN(dt.getTime())) return { local: "TBA", et: "TBA", iso: utcIso };

  const localTz =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";

  const fmt = (tz) =>
    new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
    }).format(dt);

  return {
    local: fmt(localTz),
    et: fmt("America/New_York"),
    iso: utcIso,
    localTz,
  };
}

export function minutesUntil(utcIso) {
  if (!utcIso) return Infinity;
  return (new Date(utcIso).getTime() - Date.now()) / 60000;
}

// Within 10 minutes of start → "join now" window is open
export function isJoinable(utcIso) {
  const m = minutesUntil(utcIso);
  return m <= 10 && m >= -60;
}

// Phase 13.3 — detect whether the user is already in Eastern Time so we can
// suppress the redundant "(ET: …)" secondary line.
const EASTERN_ZONES = new Set([
  "America/New_York",
  "America/Detroit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Indiana/Indianapolis",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Toronto",
  "America/Nassau",
  "US/Eastern",
]);

export function isEasternTimezone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return EASTERN_ZONES.has(tz);
  } catch {
    return false;
  }
}
